import { render } from "./g-color-edit.vue?vue&type=template&id=7db82e6c&ts=true"
import script from "./g-color-edit.vue?vue&type=script&lang=tsx"
export * from "./g-color-edit.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__